import { getBrowserAgent } from "@/config/newrelic";

export type IdentifyBrowserSessionOptions = {
  userId: string;
  userRole?: string;
  accountId?: string;
  locale?: string;
  supportMode: boolean;
};

function setOptionalAttribute(
  name: "userRole" | "accountId" | "locale",
  value: string | undefined
) {
  const agent = getBrowserAgent();
  if (!agent) return;

  if (value === undefined || value.length === 0) {
    agent.setCustomAttribute(name, null);
    return;
  }

  agent.setCustomAttribute(name, value);
}

/** Attaches the signed-in user and account to subsequent New Relic events. */
export function identifyBrowserSession(options: IdentifyBrowserSessionOptions) {
  const agent = getBrowserAgent();
  if (!agent) return;

  agent.setUserId(options.userId);
  setOptionalAttribute("userRole", options.userRole);
  setOptionalAttribute("accountId", options.accountId);
  setOptionalAttribute("locale", options.locale);
  agent.setCustomAttribute("supportMode", options.supportMode);
}

/** Drops user-scoped attributes so the next visitor is not attributed to this session. */
export function clearNewRelicSession() {
  const agent = getBrowserAgent();
  if (!agent) return;

  agent.setUserId(null);
  agent.setCustomAttribute("userRole", null);
  agent.setCustomAttribute("accountId", null);
  agent.setCustomAttribute("locale", null);
  agent.setCustomAttribute("supportMode", null);
}
